import { Injectable } from '@angular/core';
import { faBold } from '@fortawesome/free-solid-svg-icons';

import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class ExportExcelService {

  constructor(
    private toastService: ToastService
  ) { }

  export(title: string, data: any[], tipoNota: number = 0) {
    if (data.length == 0) {
      this.toastService.warning('No hay registros para descargar.');
      return;
    }

    this._export({
      title,
      headers: Object.keys(data[0]),
      data: data.map(x => Object.values(x)),
    },
      tipoNota
    );
  }

  private _export(excelData: { title: string, headers: any, data: any[] }, tipoNota: number) {
    const title = excelData.title;
    const header = excelData.headers
    const data = excelData.data
    let fechaCorteTemp = "";
    if (header[header.length - 1] == "FechaETL") {
      fechaCorteTemp = data[0][header.length - 1];
      data.forEach(element => {
        delete element[header.length - 1]
      });
      delete header[header.length - 1];
      header.length = header.length - 1;
    }

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Hoja 1');

    //Add Row and formatting
    worksheet.mergeCells(1, 1, 2, header.length - 1);

    let titleRow = worksheet.getCell('A1');
    titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 14,
      underline: 'single',
      bold: true,
      color: { argb: '412e80' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }

    let d = new Date();
    let date = 'Fecha: ' + d.getDate() + '/' + (d.getMonth() + 1 > 9 ? (d.getMonth() + 1) : '0' + (d.getMonth() + 1)) + '/' + d.getFullYear();
    let dateCell;
    if (header != null) {
      dateCell = worksheet.getCell(1, header.length);
    } else {
      dateCell = worksheet.getCell('G1');
    }
    dateCell.value = date;
    dateCell.font = {
      name: 'Calibri',
      size: 11,
      bold: false
    }
    dateCell.alignment = { vertical: 'middle', horizontal: 'left' }

    const e = new Date();
    let h = addZero(e.getHours());
    let m = addZero(e.getMinutes());
    let s = addZero(e.getSeconds());
    let time = 'Hora: ' + h + ":" + m + ":" + s;

    let hourCell;
    if (data[0] != null) {
      hourCell = worksheet.getCell(2, header.length);
    } else {
      hourCell = worksheet.getCell('G3');
    }
    hourCell.value = time;
    hourCell.font = {
      name: 'Calibri',
      size: 11,
      bold: false
    }
    hourCell.alignment = { vertical: 'middle', horizontal: 'left' }


    //Adding Header Row
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '412e80' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
    })

    // Adding Data with Conditional Formatting
    data.forEach(d => {
      let row = worksheet.addRow(d);
    });

    worksheet.columns.forEach(function (column, i) {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        var columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
      column.width = maxLength > 50 ? 50 : maxLength;
    });
    // Footer Row
    worksheet.addRow('');
    let footerRow = worksheet.addRow(['Total de Registros: ' + data.length]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF' },
      bgColor: { argb: '' }
    }

    footerRow.getCell(1).font = {
      name: 'Calibri',
      size: 12,
      bold: true
    };

    worksheet.addRow('');

    if (tipoNota == 0) {
      // let fuente = worksheet.addRow(['Fuentes: Informes Técnicos de Licenciamiento, Sunedu, 2020. Quacquarelli Symonds World University Rankings, 2021 y SCImago Research Group, 2021.']);
      // let fuente2 = worksheet.addRow(['Notas: ¹Para el Nivel de certificación docente, el nivel 5 es el de mayor desempeño, mientras que el nivel 1 es el de menor desempeño.']);
      // let fuente3 = worksheet.addRow(['S.D.: No cuenta con la información suficiente para el cálculo del indicador.']);
      // fuente.getCell(1).fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: 'FFFFFF' }
      // };

      // fuente2.getCell(1).fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: 'FFFFFF' }
      // };

      // fuente3.getCell(1).fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: 'FFFFFF' }
      // };

    }

    let dateCorte = new Date(fechaCorteTemp);
    let aCorte = dateCorte.getFullYear();
    let dCorte = dateCorte.getDate();
    let mCorte = dateCorte.getMonth();

    if (tipoNota == 1) {
      let fuente = worksheet.addRow(['Fuente: Informes Técnicos de Licenciamiento, Sunedu, 2020; Sistema de Información Universitaria (SIU) administrado por la Unidad de Documentación e Información Universitaria de la Superintendencia Nacional de Educación Superior Universitaria (Sunedu).']);
      let fuente2 = worksheet.addRow(['Nota: Información actualizada al ' + dCorte + " de " + getMesNombre((dateCorte.getMonth() + 1 > 9 ? (dateCorte.getMonth() + 1) : '0' + (dateCorte.getMonth() + 1))) + ' de ' + aCorte + ". " /*+ 'Para el caso de docentes en el año 2022 la información corresponde al periodo 2022-1.'*/]);
      // let fuente3 = worksheet.addRow(['S.D.: No cuenta con la información suficiente para el cálculo del indicador.']);
      fuente.getCell(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF' }
      };

      fuente2.getCell(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF' }
      };

    }

    if (tipoNota == 2) {
      let fuente = worksheet.addRow(['Fuente: Sistema de Información Universitaria (SIU) administrado por la Unidad de Documentación e Información Universitaria de la Superintendencia Nacional de Educación Superior Universitaria (Sunedu).']);
      let fuente2 = worksheet.addRow(['Nota: Información actualizada al ' + dCorte + " de " + getMesNombre((dateCorte.getMonth() + 1 > 9 ? (dateCorte.getMonth() + 1) : '0' + (dateCorte.getMonth() + 1))) + ' de ' + aCorte + "."]);
      let fuente3 = worksheet.addRow(['Discapacitado: Son aquellas personas que cuentan con el certificado de discapacidad emitido por el Ministerio de Salud el cual acredita la condición de persona con discapacidad.']);
      // let fuente3 = worksheet.addRow(['S.D.: No cuenta con la información suficiente para el cálculo del indicador.']);
      fuente.getCell(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF' }
      };

      fuente2.getCell(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF' }
      };

      fuente3.getCell(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF' }
      };
    }

    // fuente3.getCell(1).fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: 'FFFFFF' }
    // };

    let fechaCorte = "18 de noviembre.";
    let anioCorte = "2021"
    // dateCorte = new Date(fechaCorteTemp);
    // aCorte = dateCorte.getFullYear();
    // dCorte = dateCorte.getDate();
    // mCorte = dateCorte.getMonth();
    // let date = 'Fecha: '+d.getDate() + '/' + (d.getMonth()+1 > 9 ? (d.getMonth() + 1) : '0' + (d.getMonth() + 1)) + '/' + d.getFullYear();
    let nota;
    // if(fechaCorteTemp != undefined && fechaCorteTemp != null && fechaCorteTemp != ""){
    //   nota = worksheet.addRow(['Nota: La información que se visualiza corresponde al año ' + aCorte + ' reportada por las universidades con fecha de corte: '+dCorte+" de "+getMesNombre((dateCorte.getMonth()+1 > 9 ? (dateCorte.getMonth() + 1) : '0' + (dateCorte.getMonth() + 1)))+"."]);
    //   nota.getCell(1).fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: 'FFFFFF' }
    //   };
    //   // Merge Cells
    //   // worksheet.mergeCells(`A${footerRow.number}:B${footerRow.number}`);
    //   worksheet.mergeCells(footerRow.number,1,footerRow.number,header.length);
    //   worksheet.mergeCells(fuente.number,1,fuente.number,header.length);
    //   worksheet.mergeCells(nota.number,1,nota.number,header.length);
    // }

    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    })

    function addZero(i) {
      if (i < 10) { i = "0" + i }
      return i;
    }


    function getMesNombre(idx) {

      var objDate = new Date();
      objDate.setDate(1);
      objDate.setMonth(idx - 1);

      var locale = "es-ES",
        month = objDate.toLocaleString(locale, { month: "long" });

      return month;
    }
  }


}
